export default {
  title: 'Luk tilgængelighed',
  close_availabilities_form: {
    date_range: {
      label: 'Vælg en dato og et tidspunkt.',
    },
  },
  reason: {
    label: 'Tilføj en årsag (valgfrit)',
    placeholder: 'Indtast beskrivelse...',
  },
  recurring: {
    label: 'Gentages årligt',
  },
  buttons: {
    save: 'Gem',
    cancel: 'Annuller',
    add: '+ Tilføj undtagelse',
    reactivate: 'Genaktiver',
  },
  reservations: {
    title: 'Reservationer',
    description: 'Vil du tilføje tidsplanundtagelsen til reservationer?',
    add: 'Tilføj',
    cancel: 'Annuller',
  },
  projects: {
    online_shop: 'Onlineshop',
    reservations: 'Reservationer',
    storefront: 'Storefront',
  },
  success_messages: {
    reservation_updated: 'Tidsplanundtagelsen blev tilføjet',
  },
  error_messages: {
    date_range_required: 'Vælg et datointerval.',
    creation_failed: 'Undtagelsen kunne ikke oprettes',
    overlapping_schedule_exception: 'Du har allerede en tidsplanundtagelse i det tidsrum',
    merge_schedule_exceptions:
      'Følgende tidsplanundtagelse {{oldDate}} bliver flettet med {{newDate}}. Du kan også opdatere datointervallet for {{oldDate}}.',
  },
};
